import styled from '@emotion/styled';
import IconButton from '@mui/material/IconButton';

import { PaletteColor } from '../../styling/AppStyles';

/**
 * A MUI <IconButton> with custom styles
 */
const ExinMuiIconButton = styled(IconButton)`
  color: ${PaletteColor.text};
  padding: 0;
`;

export default ExinMuiIconButton;
